import { connect } from "react-redux";
import {
    Grid,
    useTheme,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';
import { useEffect, useState } from "react";

const AuthenticationLayoutUko = (props) => {
    const { children, title, logoApp, logoSignIn } = props;
    const [backgroundSize, setBackgroundSize] = useState(null);
    const [imageLoaded, setImageLoaded] = useState(false);
    const theme = useTheme();
    const classes = useStyles();

   useEffect(() => {
    if (!logoApp) return;

    setImageLoaded(false);
    setBackgroundSize(null);

    const img = new Image();
    img.src = logoApp;

    img.onload = () => {
      const isLargeImage = img.naturalWidth > 1000 || img.naturalHeight > 1000;

      setBackgroundSize(isLargeImage ? "cover" : "auto");
      setImageLoaded(true);
    };
  }, [logoApp]);

    return (
        <Grid container style={{ minHeight: "100vh" }} >
            <Grid item md={6} xs={12} className={classes.gridOrderFirst} >
                <Box
                    style={{
                        height: "100%",
                        width: "100%",
                        backgroundImage: imageLoaded ? `url(${logoApp})` : "none",
                        backgroundSize: backgroundSize || "auto",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundColor: theme.palette.primary.light,
                        opacity: imageLoaded ? 1 : 0
                    }}
                />
            </Grid>
            <Grid item md={6} xs={12} className={classes.gridOrderData} style={{ background: theme.palette.secondary.light, display:"flex", justifyContent:"center" }}>
                <Box style={{ display: "flex", alignItems:"center", justifyContent:"center", height:"100%" }} >
                    <Box style={{ textAlign:"center", maxWidth:"550px", width:"100%", padding:"32px" }}>
                        <img src={logoSignIn} alt="Logo" width={theme.widthImageLogo || '112px'} />
                        <h1 style={{ fontWeight: "700", fontStyle:'normal', fontSize: "22px", marginTop: "56px", fontFamily: "Montserrat", lineHeight: "100%", letterSpacing: "0%", color: theme.palette.secondary.titleText}}>
                            {title}
                        </h1>
                        {children}
                    </Box>
                </Box>
            </Grid>
        </Grid>
    );
};

AuthenticationLayoutUko.propTypes = {
};
const mapStateToProps = (state) => ({
});
export default connect(mapStateToProps, {
})(AuthenticationLayoutUko);

const useStyles = makeStyles((theme) => ({
    gridOrderFirst: {
        [theme.breakpoints.up('md')]: {
            order: 1,
        },
        [theme.breakpoints.down('md')]: {
            order: 2,
        },
    },
    gridOrderData: {
        [theme.breakpoints.down('md')]: {
            order: 1,
        },
        [theme.breakpoints.up('md')]: {
            order: 2,
        },
    },
}));